import axios from 'axios';
import router from '../../router';
import store from '../../store';
import errorTips from '../message/index';
import { CONSTS } from '../consts'
import { setSessionStorage } from '../../untils/storage';
// 创建实例
const instance = axios.create();
const FRAME_PREFIX = CONSTS.contextPath + '';

// 全局默认配置
instance.defaults.timeout = 300000;
instance.defaults.headers['X-Requested-With'] = 'XMLHttpRequest';
instance.defaults.headers['Content-Type'] = 'application/json;charset=UTF-8';
axios.defaults.headers.get['Cache-Control'] = 'no-cache'
axios.defaults.headers.get['Pragma'] = 'no-cache'
instance.defaults.withCredentials = true;
instance.defaults.baseURL = process.env.NODE_ENV == 'production'
  ? FRAME_PREFIX
  : '/api';

// 添加一个响应拦截器
instance.interceptors.response.use(response => {
  setSessionStorage('status', response.data)

  if (response.status == 200) {
    const status = response.data.status,
      path = router.currentRoute.path;
    switch (status) {
      case 200:
        return Promise.resolve(response.data.result);
      case 201: // 缺少userId，需登录获取       
        return Promise.reject(response.data.msg);
      case 401:
        console.log(response)
        store.commit('CHANGE_LOGSTATE', false);
        router.replace({ name: 'Login', params: { redirect: path } });
        return Promise.resolve('');
      default:
        return Promise.reject(response.data.msg);
    }
  }
  return Promise.reject(response);
}, error => {
  if (error.response) {
    const status = error.response.status;
    switch (status) {
      case 500:
        errorTips('服务器异常');
        break;
      case 404:
        errorTips('服务器链接中断');
        break;
      default:
        errorTips(error.response.statusText);
    };
  } else {
    errorTips(error);
  }
});

export default instance;



// WEBPACK FOOTER //
// ./src/untils/axios/instance.js